import _chunk from "lodash/chunk";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import { useRef } from 'react';
import { PillButton } from "../PillButton";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map(function (month, idx) {
  return {
    label: month,
    value: idx
  };
});
var NUM_COLUMNS = 3;
export function MonthPicker(_ref) {
  var _ref$maxMonth = _ref.maxMonth,
    maxMonth = _ref$maxMonth === void 0 ? 11 : _ref$maxMonth,
    _ref$minMonth = _ref.minMonth,
    minMonth = _ref$minMonth === void 0 ? 0 : _ref$minMonth,
    onChange = _ref.onChange,
    value = _ref.value,
    year = _ref.year;
  var rows = _chunk(MONTHS_SHORT, NUM_COLUMNS);
  var ref = useRef(null);
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    _jsx("table", {
      ref: ref,
      role: "grid",
      children: _jsx("tbody", {
        children: rows.map(function (row, rowIndex) {
          return _jsx("tr", {
            children: row.map(function (_ref2, colIndex) {
              var label = _ref2.label,
                monthValue = _ref2.value;
              var disabled = monthValue < minMonth || monthValue > maxMonth;
              return _jsx("td", {
                children: _jsx(PillButton, {
                  "aria-label": "".concat(label, " ").concat(year),
                  disabled: disabled,
                  isSelected: value === monthValue,
                  onClick: function onClick() {
                    return onChange(monthValue);
                  },
                  onKeyDown: function onKeyDown(e) {
                    var _ref$current;
                    var amount = e.key === 'ArrowUp' ? -NUM_COLUMNS : e.key === 'ArrowDown' ? NUM_COLUMNS : e.key === 'ArrowLeft' ? -1 : e.key === 'ArrowRight' ? 1 : 0;
                    var currentIndex = MONTHS_SHORT.findIndex(function (val) {
                      return val.value === monthValue;
                    });
                    var newIndex = currentIndex + amount;
                    var monthToGoTo = MONTHS_SHORT[newIndex];
                    if (amount === 0 || !monthToGoTo || monthToGoTo.value < minMonth || monthToGoTo.value > maxMonth) {
                      return;
                    }
                    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll('button').item(newIndex).focus();
                  },
                  tabIndex: monthValue === value ? 0 : (!value || value < minMonth || value > maxMonth) && monthValue === minMonth ? 0 : -1,
                  variant: "month",
                  children: label
                }, monthValue)
              }, colIndex);
            })
          }, rowIndex);
        })
      })
    })
  );
}